import { createSlice } from '@reduxjs/toolkit';
import { API } from 'aws-amplify';
import { LocalCache } from '../libreria/LocalCache';

export const notascobroFolioSlice = createSlice({
  name: 'notascobroFolio',
  initialState: {
    rows: []
  },
  reducers: {
    setNotasCobroFolio: (state, action) => {
      state.rows = action.payload;
    }
  }
});

export const { setNotasCobroFolio } = notascobroFolioSlice.actions;

// Action Creators
export const getNotasCobroFolio = (comunidadId, folio) => async (dispatch, getState) => {
  let item = LocalCache.get(`KEY:notascobroFolio&comunidad=${comunidadId}&folio=${folio}`);
  if (item) {
    dispatch(setNotasCobroFolio(item));
  } else {
    try {
      const response = await API.get('ePlat', `/notascobro-folio?comunidad=${comunidadId}&folio=${folio}`);
      dispatch(setNotasCobroFolio(response));
      LocalCache.put(`KEY:notascobroFolio&comunidad=${comunidadId}&folio=${folio}`, response);
    } catch (error) {
      console.log('DVD: ERROR Llamada a getNotasCobroFolio()', error);
    }
  }
};

export default notascobroFolioSlice.reducer;
